import { all, call, put, takeEvery } from "redux-saga/effects";

import { enqueueSnackbar } from "../snack/actions";

import { ErrorLoadingActionCreator } from "./actions";

function* notifyOnError() {
  yield takeEvery(
    ErrorLoadingActionCreator.toString(),
    function* handler(action: ReturnType<typeof ErrorLoadingActionCreator>) {
      yield put(enqueueSnackbar({ message: action.payload.error, options: { variant: "error" } }));
    }
  );
}

export function* loadingSagas() {
  yield all([call(notifyOnError)]);
}
